import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError, of } from "rxjs";
import { catchError, map, retry, switchMap, tap } from "rxjs/operators";
import {
  ApiMapperDetailsViewModel,
  EAuthorizationType,
  ETokenSource
} from "@ui-components/models";

@Injectable({
  providedIn: "root",
})
export class DataSourcesService {
  datasourcesList = {};

  constructor(private http: HttpClient) { }

  public getDataSourceList() {
    return this.http.get("/ApiInvoker/GetDataSourceListBySiteId");
  }
  public invokeDataSource(
    dataSourceId: number,
    dataSourceParams: any,
    isCallAuthorizationInBackend: boolean = false
  ) {

    let token = localStorage.getItem("coreToken");
    const apiUrl =  !token || token == ''? this.getDataSourceById(dataSourceId) :
      this.invoke(dataSourceId, dataSourceParams, { headers: new HttpHeaders({}) });
    return apiUrl.pipe(
      switchMap(
        (res: any) => {
          // if (isCallAuthorizationInBackend && token) {
          //   token = res.token ;
          // }
          let requestOptions = { headers: new HttpHeaders({}) };

          if (!token || token == '') {
            if (res && res.token && res.token != '') {
              requestOptions = {
                headers: new HttpHeaders(
                  { token: res.token }
                ),
              };
            }
            return this.invoke(dataSourceId, dataSourceParams, requestOptions);

          } else {
            return of(res);
          }

          // if (
          //   res.authorizationType !== EAuthorizationType.Basic &&
          //   res.authorizationType !== EAuthorizationType.None
          // ) {
          //   requestOptions = {
          //     headers: new HttpHeaders({
          //       token: res.token,
          //     }),
          //   };
          // }

        }
      )
    );
  }

  private invoke(
    dataSourceId,
    dataSourceParams,
    requestOptions = {
      headers: new HttpHeaders({}),
    }
  ) {
    return this.http
      .post<any>(
        `/ApiInvoker/Invoke/${dataSourceId}`,
        dataSourceParams,
        requestOptions
      )
      .pipe(
        catchError((err) => {
          // if (err.status == "401" && res.apiUrl.includes('CoreApplications')) {
          //   this.refreshToken(res.token, res.refreshToken)
          //     .subscribe(res => {
          //       return of(null)
          //     });
          // } else {
          return throwError(err);
          // }
        })
      );
  }

  private refreshToken(token: string, refreshToken: string) {
    const data = {
      Token: token,
      RefreshToken: refreshToken,
      inputType: ["Token", "RefreshToken"],
    };
    return this.invokeDataSource(20, data).pipe(
      tap((res) => {
        if (res) {
          const coreData = res["content"];
          localStorage.setItem("coreToken", coreData["Token"]);
          localStorage.setItem("coreRefreshToken", coreData["RefreshToken"]);
        }
      })
    );
  }

  private getDataSourceById(
    dataSourceId: number  ) {
    return this.http
      .get<ApiMapperDetailsViewModel>(
        `/ApiInvoker/GetApiMapperById/${dataSourceId}`
      )
      .pipe(
        switchMap((result: ApiMapperDetailsViewModel) => {
          let resultObs: Observable<any>;
          let tokenObj = result.authorizationKeys.find(
            (x) => x.key == "LocalStorageToken"
          );
          let refreshTokenObj = result.authorizationKeys.find(
            (x) => x.key == "LocalStorageRefreshToken"
          );
          switch (result.authorizationType) {
            case 2: {
              //JWT
              switch (tokenObj.tokenSource) {
                case 2: {
                  // DataBase
                  this.http
                    .get(
                      `/ApiInvoker/GetAuthentication/${tokenObj.value}/${refreshTokenObj.value}`
                    )
                    .subscribe((res: any[]) => {
                      let tokenDB = res.find(
                        (x) => x.propertyName == tokenObj.value
                      );
                      let refreshTokenDB = res.find(
                        (x) => x.propertyName == refreshTokenObj.value
                      );
                      resultObs = of({
                        token: tokenDB.value,
                        authorizationType: 2,
                        apiUrl: result.url,
                        refreshToken: refreshTokenDB.value,
                      });
                    });
                  break;
                }
                case 1: {
                  //Localstorage
                  let lsToken = localStorage.getItem(tokenObj.value);
                  let lsRefreshToken = localStorage.getItem(
                    refreshTokenObj.value
                  );
                  if (lsToken) {
                    lsToken =
                      lsToken && this.isJson(lsToken)
                        ? JSON.parse(lsToken)
                        : lsToken;
                    lsRefreshToken = localStorage.getItem(
                      refreshTokenObj.value
                    );
                    lsRefreshToken =
                      lsRefreshToken && this.isJson(lsRefreshToken)
                        ? JSON.parse(lsRefreshToken)
                        : lsRefreshToken;
                    resultObs = of({
                      token: lsToken,
                      authorizationType: 2,
                      apiUrl: result.url,
                      refreshToken: lsRefreshToken,
                    });
                  }  else {
                    const token = localStorage.getItem("coreToken");
                    if (!!token) {
                      resultObs = of({
                        token: token,
                        authorizationType: 2,
                        apiUrl: null,
                        refreshToken: null,
                      });
                    } else {
                      return this.callParentAPI(result.parentId, tokenObj.key);
                    }
                  }
                  // else if (isCallAuthorizationInBackend) {
                  //   const token = localStorage.getItem("coreToken");
                  //   if (!!token) {
                  //     resultObs = of({
                  //       token: token,
                  //       authorizationType: EAuthorizationType.JWT,
                  //       apiUrl: null,
                  //       refreshToken: null,
                  //     });
                  //   } else {
                  //     return this.callParentAPI(result.parentId, tokenObj.key);
                  //   }
                  // }
                  // else {
                  //   resultObs = of({
                  //     token: lsToken,
                  //     authorizationType: EAuthorizationType.JWT,
                  //     apiUrl: result.url,
                  //     refreshToken: lsRefreshToken,
                  //   });
                  // }

                  break;
                }
              }
              break;
            }
            case 1: {
              // Basic authorization
              resultObs = of({
                token: "",
                authorizationType: 1,
                apiUrl: null,
                refreshToken: "",
              });
              break;
            }
            case 0: {
              //None authorization
              resultObs = of({
                token: "",
                authorizationType: 0,
                apiUrl: null,
                refreshToken: "",
              });
              break;
            }
          }
          return resultObs;
        })
      );
  }

  isJson(value): boolean {
    try {
      JSON.parse(value);
      return true;
    } catch (error) {
      return false;
    }
  }

  callParentAPI(parentId, localStorageName) {
    // debugger;
    const coreLoginGo = {
      // USERNAME: "ADMIN",
      // PASSWORD: "Eska@1234",
      // COMPANYID: 1,
      // BRANCHID: 1,
    };

    return this.invoke(parentId, coreLoginGo).pipe(
      switchMap(
        (res: any) => {
          if (res) localStorage.setItem("coreToken", JSON.parse(res));
          return of({
            token: res? JSON.parse(res) : '',
            authorizationType: 2,
            apiUrl: null,
            refreshToken: null,
          });
        }
      )
    );
  }

  resetList() {
    this.datasourcesList = {};
  }
}
